import type { GenieKnowledgeEntry } from '../../types';

/** Fallback genérico cuando el motor detecta desmielinización sin subtipo */
export const demyelinatingNeuropathy: GenieKnowledgeEntry = {
  id: 'demyelinating_neuropathy',
  name: 'Neuropatía Desmielinizante',
  category: 'neuropatico',
  conversation: {
    headline:
      'Patrón desmielinizante detectado. Diferencie agudo (GBS) vs crónico (CIDP) por curso clínico.',
    edxHighlights: [
      'VCM <70% LIN, LMD >150% LSN, bloqueos o dispersión temporal',
      'Curso agudo (<4 sem) → GBS; crónico (>8 sem) → CIDP',
      'Desmielinización segmentaria adquirida = tratable con inmunoterapia',
      'Desmielinización uniforme bilateral → considerar CMT hereditaria',
    ],
    pearls: [
      'Temperatura fría simula desmielinización — verificar antes de concluir.',
      'Un solo nervio en sitio de atrapamiento no define polineuropatía desmielinizante.',
    ],
    differentials: [
      { name: 'GBS', distinguishingHint: 'agudo, arreflexia, debilidad ascendente' },
      { name: 'CIDP', distinguishingHint: 'crónico progresivo o recidivante' },
    ],
    nextSteps: [
      'Correlacionar con curso temporal clínico',
      'Repetir NCS si estudio temprano en sospecha de GBS',
    ],
  },
};
